let cachedMegaPuzzles = null;

const THEME_NAMES = {
    'matein1': "Mate in 1 🏆", 'matein2': "Mate in 2 🏆", 'matein3': "Mate in 3+ 🏆",
    'backrankmate': "Back-Rank Mate 🚪", 'smotheredmate': "Smothered Mate 🗜️",
    'fork': "The Fork 🔱", 'pin': "The Pin 📌", 'skewer': "The Skewer 🍢",
    'discoveredattack': "Discovered Attack 👻", 'doublecheck': "Double Check ‼️",
    'endgame': "Endgame Master ⏳", 'opening': "Opening Traps 🪤", 'middlegame': "Middlegame Clash ⚔️"
};

const getLichessDb = async () => {
    if (!cachedMegaPuzzles) {
        const jsonPath = process.env.PUBLIC_URL ? `${process.env.PUBLIC_URL}/master_puzzles.json` : '/master_puzzles.json';
        const response = await fetch(jsonPath);
        if (!response.ok) throw new Error("JSON File not found on server");
        cachedMegaPuzzles = await response.json();
    }
    
    let db = cachedMegaPuzzles;
    if (!Array.isArray(db)) {
        if (db.puzzles && Array.isArray(db.puzzles)) db = db.puzzles;
        else {
            let flat = [];
            Object.values(db).forEach(v => {
                if(typeof v === 'object') Object.values(v).forEach(arr => flat = flat.concat(arr));
            });
            db = flat;
        }
    }
    return db;
};

// 🔥 PERFECT PARSER FOR ALL FORMATS
export const fetchLichessPuzzles = async (themeTag, count = 15) => {
    try {
        const allPuzzles = await getLichessDb();
        let themePuzzles = allPuzzles;
        
        if (themeTag !== 'mixed') {
            themePuzzles = allPuzzles.filter(p => {
                const themes = String(p.Themes || p.themes || p.theme || "").toLowerCase();
                return themes.includes(themeTag.toLowerCase());
            });
        }

        if (themePuzzles.length === 0) return [];

        themePuzzles.sort((a, b) => parseInt(a.Rating || a.rating || 1000) - parseInt(b.Rating || b.rating || 1000));
        
        const easiestPool = themePuzzles.slice(0, Math.max(count * 3, 50));
        const selectedPuzzles = easiestPool.sort(() => 0.5 - Math.random()).slice(0, count);

        return selectedPuzzles.map((p, index) => {
            // 🔥 SMART SPLITTER
            let oppMove = null;
            let playerSol = [];

            if (p.opponentMove !== undefined && p.solution) {
                // For custom arrays where Opponent Move is explicitly separated
                oppMove = p.opponentMove && p.opponentMove.length >= 4 ? p.opponentMove : null;
                playerSol = Array.isArray(p.solution) ? p.solution : p.solution.split(/\s+/);
            } else {
                // For Standard Lichess Strings ("e2e4 c7c5")
                const movesStr = p.Moves || p.moves || p.solution || "";
                const movesArr = Array.isArray(movesStr) ? movesStr : movesStr.trim().split(/\s+/);
                if (movesArr.length > 0) {
                    oppMove = movesArr[0]; 
                    playerSol = movesArr.slice(1);
                }
            }

            return {
                id: p.PuzzleId || p.puzzleId || `puzzle_${index}`,
                theme: themeTag, 
                fen: p.FEN || p.fen, 
                opponentMove: oppMove, 
                solution: playerSol, 
                rating: p.Rating || p.rating || '?',
            };
        });
        
    } catch (error) { return []; }
};

export const generateHomeworkSet = async (levelId, chapterId, themeName = "Tactics") => {
    try {
        const allPuzzles = await getLichessDb();
        let filtered = allPuzzles;
        let targetTheme = "";

        if (String(levelId).startsWith('TACTICS_')) targetTheme = String(levelId).split('_')[1] || 'mixed';
        else if (String(levelId).startsWith('KIDS_')) targetTheme = 'matein1';

        if (targetTheme && targetTheme !== 'mixed') {
            filtered = allPuzzles.filter(p => String(p.Themes || p.themes || p.theme || "").toLowerCase().includes(targetTheme.toLowerCase()));
        }
        if (filtered.length === 0) filtered = allPuzzles;
        
        if (String(levelId).startsWith('KIDS_')) {
            filtered.sort((a,b) => parseInt(a.Rating||1000) - parseInt(b.Rating||1000));
            filtered = filtered.slice(0, 50);
        }
        const selected = filtered.sort(() => 0.5 - Math.random()).slice(0, 20);

        return selected.map((p, index) => {
            let oppMove = null; let playerSol = [];
            if (p.opponentMove !== undefined && p.solution) {
                oppMove = p.opponentMove && p.opponentMove.length >= 4 ? p.opponentMove : null;
                playerSol = Array.isArray(p.solution) ? p.solution : p.solution.split(/\s+/);
            } else {
                const movesStr = p.Moves || p.moves || p.solution || "";
                const movesArr = Array.isArray(movesStr) ? movesStr : movesStr.trim().split(/\s+/);
                if (movesArr.length > 0) { oppMove = movesArr[0]; playerSol = movesArr.slice(1); }
            }
            return {
                id: p.PuzzleId || p.id || `hw_${levelId}_${index}`,
                puzzleNumber: index + 1, theme: themeName || "Training",
                fen: p.FEN || p.fen, opponentMove: oppMove, solution: playerSol,
                rating: p.Rating || p.rating || 1000, instruction: "Find the best move"
            }
        });
    } catch (error) { return []; }
};
